import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle, MapPin, Smartphone, Clock } from 'lucide-react';
export function ProblemSection() {
  const problems = [{
    icon: <Smartphone className="h-6 w-6 text-china-red" data-id="element-228" />,
    text: 'No saber si vas a poder pagar cuando toque.'
  }, {
    icon: <MapPin className="h-6 w-6 text-china-red" data-id="element-229" />,
    text: 'No saber si vas a poder moverte sin perderte.'
  }, {
    icon: <AlertCircle className="h-6 w-6 text-china-red" data-id="element-230" />,
    text: 'No tener claro qué app usar para cada cosa.'
  }, {
    icon: <Clock className="h-6 w-6 text-china-red" data-id="element-231" />,
    text: "Llegar a la noche y perder 2 horas rehaciendo la ruta porque 'no cuadra'."
  }];
  return <section className="py-10 lg:py-20 px-4 sm:px-6 lg:px-8 bg-off-white border-t border-cream-dark" data-id="element-232">
      <div className="max-w-5xl mx-auto" data-id="element-233">
        <div className="text-center mb-8 lg:mb-16" data-id="element-234">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-charcoal mb-2 lg:mb-4" data-id="element-235">
            El problema (sin dramatizar, pero real)
          </h2>
          <p className="text-base lg:text-xl text-charcoal-light max-w-2xl mx-auto" data-id="element-236">
            No te estresa "China". Te estresa esto:
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 lg:gap-8" data-id="element-237">
          {problems.map((problem, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white p-4 lg:p-6 rounded-xl shadow-sm border border-gray-100 flex items-start" data-id="element-238">
              <div className="flex-shrink-0 p-2 lg:p-3 bg-cream rounded-full mr-3 lg:mr-4" data-id="element-239">
                {problem.icon}
              </div>
              <p className="text-base lg:text-lg text-charcoal pt-1 lg:pt-2 font-medium" data-id="element-240">
                {problem.text}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.5
      }} className="mt-8 lg:mt-12 text-center" data-id="element-241">
          <p className="text-base sm:text-lg lg:text-xl font-serif italic text-china-red font-medium" data-id="element-242">
            Y lo peor: sentir que el viaje se te escapa en micro‑problemas
            tontos.
          </p>
        </motion.div>
      </div>
    </section>;
}